var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['basic-dialog', { hidden: _vm.hidden }],style:({ '--duration': `${_vm.duration}s` })},[_c('div',{staticClass:"dialog-box"},[_c('div',{staticClass:"dialog-box_header"},[_vm._t("header")],2),_c('div',{staticClass:"dialog-box_content"},[_vm._t("default")],2),_c('div',{staticClass:"dialog-box_footer"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }